import api from '@/utils/api';
import {
    CUSTOMER_PROSPECT_LIST,
    CUSTOMER_PROSPECT_GET,
    CUSTOMER_PROSPECT_UPDATE,
    CUSTOMER_PROSPECT_CREATE,
    CUSTOMER_PROSPECT_DELETE,
    CUSTOMER_PROSPECT_LIST_ACTIVE,
    CUSTOMER_PROSPECT_LIST_NAME,
    CUSTOMER_PROSPECT_IMPORT,
} from './types';
import { NotificationManager } from 'react-notifications';

const ROUTE = '/customer-prospects';

export const getCustomerProspects = (params) => (dispatch) => {
    return api
        .get(ROUTE, { params })
        .then((res) => {
            dispatch({ type: CUSTOMER_PROSPECT_LIST, payload: res.data.data });
            return res.data;
        })
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
            throw err;
        });
};

export const getCustomerProspect = (id) => (dispatch) => {
    return api
        .get(`${ROUTE}/${id}`)
        .then((res) => {
            dispatch({ type: CUSTOMER_PROSPECT_GET, payload: res.data.data });
            return res.data.data;
        })
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
            throw err;
        });
};

export const createCustomerProspect = (data) => (dispatch) => {
    return api
        .post(ROUTE, data)
        .then((res) => {
            dispatch({ type: CUSTOMER_PROSPECT_CREATE, payload: res.data.data });
            NotificationManager.success('Thêm mới bản ghi thành công!');
            return res.data.data;
        })
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
            throw err;
        });
};

export const updateCustomerProspect = (id, data) => (dispatch) => {
    return api
        .put(`${ROUTE}/${id}`, data)
        .then((res) => {
            dispatch({ type: CUSTOMER_PROSPECT_UPDATE, payload: res.data.data });
            NotificationManager.success('Cập nhật bản ghi thành công!');
            return res.data;
        })
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
            throw err;
        });
};

// delete nhiều prospect theo ids
export const deleteCustomerProspects = (ids) => (dispatch) => {
    return api
        .delete(ROUTE, { data: { ids } })
        .then((res) => {
            dispatch({ type: CUSTOMER_PROSPECT_DELETE, payload: ids });
            NotificationManager.success('Xoá bản ghi thành công!');
            return res.data;
        })
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
            throw err;
        });
};

export const importCustomerProspects = (data, header) => (dispatch) => {
    return api
        .post(`${ROUTE}/import`, data, header)
        .then((res) => {
            dispatch({ type: CUSTOMER_PROSPECT_IMPORT, payload: res });
            return res;
        })
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
            throw err;
        });
};

export const getActiveCustomerProspects = (params) => (dispatch) => {
    return api
        .get(`${ROUTE}`, { params })
        .then((res) => {
            dispatch({ type: CUSTOMER_PROSPECT_LIST_ACTIVE, payload: res.data.data });
            return res.data;
        })
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
            throw err;
        });
};

export const getCustomerProspectNames = (params) => (dispatch) => {
    return api
        .get(`${ROUTE}/list-names`, { params })
        .then((res) => {
            dispatch({ type: CUSTOMER_PROSPECT_LIST_NAME, payload: res.data });
            return res.data;
        })
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Có lỗi xảy ra');
            throw err;
        });
};

export const exportCustomerProspects = (filter) => () => {
    return api
        .post(`${ROUTE}/export`, filter)
        .then((res) => res.data.data)
        .catch((err) => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể xuất file. Vui lòng thử lại.');
            throw err;
        });
};
